export default __webpack_public_path__ + "static/media/Composite_2_DSC_810_0026_.1091b4d8.jpg";